/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-pending': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM7.187 6.875A1.563 1.563 0 108.75 8.438a1.55 1.55 0 00-1.563-1.563zm5.625 0a1.563 1.563 0 101.563 1.563 1.55 1.55 0 00-1.563-1.563z"/>'
  }
})
